"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="9284" id="hero" className="relative w-full bg-background text-foreground overflow-hidden py-32 md:py-48 min-h-[92vh] flex flex-col justify-center">
      {}
      <div ref={textRef} className="relative z-10 mx-auto w-full max-w-[880px] px-6 md:px-8 text-center">
        <p className="font-default text-foreground/60 uppercase mb-8 md:mb-10 transition-all duration-700 ease-out" style={{
        fontSize: "clamp(0.75rem, 0.8vw, 0.8125rem)",
        letterSpacing: "0.14em",
        fontWeight: 500,
        opacity: textVisible ? 1 : 0,
        transform: textVisible ? "translateY(0)" : "translateY(24px)",
        transitionDelay: "0ms"
      }}>
          Professional Consulting Services
        </p>

        <h1 className="font-default text-foreground mb-8 md:mb-10 transition-all duration-700 ease-out" style={{
        fontSize: "clamp(2.75rem, 6.2vw, 5.5rem)",
        fontWeight: 700,
        letterSpacing: "-0.022em",
        lineHeight: 0.98,
        opacity: textVisible ? 1 : 0,
        transform: textVisible ? "translateY(0)" : "translateY(24px)",
        transitionDelay: "80ms"
      }}>
          {"Drive your "}
          <span className="font-default italic relative inline-block" style={{
          textDecoration: "underline",
          textDecorationColor: "var(--secondary)",
          textDecorationThickness: "2px",
          textUnderlineOffset: "6px"
        }}>
            strategy
          </span>
          {", achieve your vision"}
        </h1>

        <p className="font-default text-foreground/80 mx-auto mb-10 md:mb-12 max-w-[520px] transition-all duration-700 ease-out" style={{
        fontSize: "clamp(1.0625rem, 1.4vw, 1.25rem)",
        fontWeight: 400,
        lineHeight: 1.55,
        opacity: textVisible ? 1 : 0,
        transform: textVisible ? "translateY(0)" : "translateY(24px)",
        transitionDelay: "160ms"
      }}>
          Tailored business solutions designed to scale your operations, optimize performance, and secure long-term growth in an ever-evolving market landscape.
        </p>

        <div className="flex flex-col md:flex-row items-stretch md:items-center justify-center gap-3 md:gap-4 transition-all duration-700 ease-out" style={{
        opacity: textVisible ? 1 : 0,
        transform: textVisible ? "translateY(0)" : "translateY(24px)",
        transitionDelay: "240ms"
      }}>
          <Button asChild size="lg" className="group rounded-lg px-7 py-4 h-auto bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 font-default text-[15px] font-medium" style={{
          letterSpacing: "0.01em"
        }}>
            <Link to="/ContactPage">
              <span>Schedule Strategy Session</span>
              <ArrowRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="rounded-lg px-7 py-4 h-auto border border-foreground bg-transparent text-foreground hover:bg-foreground hover:text-background transition-all duration-300 font-default text-[15px] font-medium" style={{
          letterSpacing: "0.01em"
        }}>
            <Link to="#">
              Explore Our Services
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div ref={imgRef} className="relative w-full mt-16 md:mt-24 overflow-hidden">
        <div className="relative w-full aspect-[4/5] md:aspect-[4/3] overflow-hidden" style={{
        clipPath: imgVisible ? "inset(0 0 0 0)" : "inset(0 0 100% 0)",
        transition: "clip-path 900ms cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/business_strategy_meeting.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/business_strategy_meeting.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/business_strategy_meeting.png-wvc-sizes" alt="Modern office setting with professional documents and digital devices on a clean desk" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" style={{
          transform: imgVisible ? "scale(1)" : "scale(1.04)",
          transition: "transform 900ms cubic-bezier(0.22, 1, 0.36, 1)"
        }} />
          {}
          <div className="absolute inset-x-0 bottom-0 h-1/3 pointer-events-none" style={{
          background: "linear-gradient(to bottom, transparent, hsl(222 47% 7% / 0.04))"
        }} />
        </div>
      </div>
    </section>;
}